import { GridRowId } from '@mui/x-data-grid-pro';
import { useCallback, useState } from 'react';

export type GridRowFileChange = {
  id: GridRowId;
  file?: File;
};

export type UseDataGridRowFileChangesState = {
  fileChanges: GridRowFileChange[];
  updateFileChanges: (fileChange: GridRowFileChange) => void;
  resetFileChange: (rowId?: GridRowId) => void;
};

export const useDataGridRowFileChangesState =
  (): UseDataGridRowFileChangesState => {
    const [fileChanges, setFileChanges] = useState<GridRowFileChange[]>([]);
    const updateFileChanges = useCallback((fileChange: GridRowFileChange) => {
      setFileChanges((oldFileChanges) => [
        ...oldFileChanges.filter((fc) => fc.id !== fileChange.id),
        fileChange,
      ]);
    }, []);
    const resetFileChange = useCallback(
      (rowId?: GridRowId) => {
        const hasFileChange = fileChanges.some((fc) => fc.id === rowId);
        if (hasFileChange) {
          setFileChanges((oldFileChanges) => [
            ...oldFileChanges.filter((fc) => fc.id !== rowId),
          ]);
        }
      },
      [fileChanges, setFileChanges],
    );

    return {
      fileChanges,
      updateFileChanges,
      resetFileChange,
    };
  };
